import { lazy } from 'react'

export const UsagePurposeVariant1 = lazy(() => import('./UsagePurposeVariant1'))
